import { useRMSelector } from 'redux/hooks';

export const useSelectArchivedTasks = () => {
  return useRMSelector((state) => state.unarchiving.archivedTasks);
};

export const useSelectPreviewExperiments = () => {
  return useRMSelector((state) => state.unarchiving.previewExperiments);
};

export const useSelectUnarchivingResults = () => {
  return useRMSelector((state) => state.unarchiving.unarchivingResults);
};
